import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ReactTable from '../Utils/ReactTable';
import { dateFormatting } from '../../Utils';

const MeterValuesTable = ({ tableData }) => {
  const data = useMemo(() => tableData, [tableData]);
  const firstEnergyActiveImportRegisterValue = data[0]?.energyActiveImportRegisterValue || 0;
  const { t } = useTranslation();

  const columns = React.useMemo(
    () => [
      {
        Header: t('timestamp'),
        accessor: 'timestamp',
        Cell: ({ cell }) => dateFormatting(cell.row.original.timestamp)
      },
      {
        Header: 'ConnectorId',
        accessor: 'chargePointConnectorId'
      },
      {
        Header: `L1 ${t('voltage')}`,
        accessor: 'l1VoltageValue'
      },
      {
        Header: `L2 ${t('voltage')}`,
        accessor: 'l2VoltageValue'
      },
      {
        Header: `L3 ${t('voltage')}`,
        accessor: 'l3VoltageValue'
      },
      {
        Header: `L1 ${t('current')}`,
        accessor: 'l1CurrentImportValue'
      },
      {
        Header: `L2 ${t('current')}`,
        accessor: 'l2CurrentImportValue'
      },
      {
        Header: `L3 ${t('current')}`,
        accessor: 'l3CurrentImportValue'
      },
      {
        Header: t('temperature'),
        accessor: 'temperature'
      },
      {
        Header: t('power_active_import'),
        accessor: 'powerActiveImportValue',
        Cell: ({ cell }) =>
          `${(cell.row.original.powerActiveImportValue / 100) * 100} ${
            cell.row.original.powerActiveImportUnit
          }`
      },
      {
        Header: t('energy_active_import'),
        accessor: 'energyActiveImportRegisterValue',
        Cell: ({ cell }) =>
          `${
            cell.row.original.energyActiveImportRegisterValue - firstEnergyActiveImportRegisterValue
          } ${cell.row.original.energyActiveImportRegisterUnit} `
      }
    ],
    [tableData]
  );

  return <ReactTable data={data} columns={columns} />;
};

MeterValuesTable.propTypes = {
  tableData: PropTypes.array.isRequired
};

export default MeterValuesTable;
